import { NgIf, NgSwitch, NgSwitchCase } from '@angular/common';
import { Component, Input } from '@angular/core';

import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzButtonSize } from 'ng-zorro-antd/button/button.component';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzMenuModule } from 'ng-zorro-antd/menu';

import { TranslateModule } from '@ngx-translate/core';

import { Dispatch } from '@ngxs-labs/dispatch-decorator';

import { MuteAlert, SetAlertRead, SetAlertResolved } from '@app/client/alerts/state/alerts-state.actions';
import { Alert } from '@app/client/alerts/state/alerts-state.models';
import { AlertMenuType, AlertSeverity } from '@app/client/settings/user/modules/alert-settings/alert-settings.model';

@Component({
  selector: 'adspt-alerts-more-actions',
  templateUrl: './alerts-more-actions.component.html',
  styleUrls: ['./alerts-more-actions.component.scss'],
  imports: [
    TranslateModule,
    NzButtonModule,
    NgIf,
    NgSwitchCase,
    NzDropDownModule,
    NzMenuModule,
    NgSwitch,
    NzDividerModule,
  ],
})
export class AlertsMoreActionsComponent {
  protected readonly AlertSeverity = AlertSeverity;

  @Dispatch()
  readonly muteAlert = (alert: Alert, muteType: AlertMenuType) => new MuteAlert(alert.definitionId, muteType);

  @Dispatch()
  readonly toggleAlertRead = (alert: Alert) => new SetAlertRead(alert.instanceId, !alert.read);

  @Dispatch()
  readonly toggleAlertResolved = (alert: Alert) => new SetAlertResolved(alert.instanceId, !alert.cleared);

  @Input()
  alert?: Alert;

  @Input()
  size?: NzButtonSize;
}
